import './IconCloseCircle.css';
import React from 'react';
import { styled } from 'linaria/lib/react';
var IconCloseCircle = function IconCloseCircle(_ref) {
  var _ref$width = _ref.width,
    width = _ref$width === void 0 ? 32 : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 32 : _ref$height,
    className = _ref.className;
  return /*#__PURE__*/React.createElement(StyledSVG, {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 32 32",
    className: className
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16767",
    "data-name": "Group 16767",
    transform: "translate(-795 -4071)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: "14.281",
    cy: "14.281",
    rx: "14.281",
    ry: "14.281",
    transform: "translate(796.739 4072.739)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "error",
    transform: "translate(795 4071)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M27.319,4.681a16.007,16.007,0,1,0,0,22.638A16.026,16.026,0,0,0,27.319,4.681ZM22.312,22.312a1.231,1.231,0,0,1-1.741,0L16,17.741l-4.789,4.789A1.231,1.231,0,1,1,9.47,20.788L14.259,16,9.687,11.428a1.231,1.231,0,1,1,1.741-1.741L16,14.259l4.353-4.353a1.231,1.231,0,0,1,1.741,1.741L17.741,16l4.571,4.571A1.231,1.231,0,0,1,22.312,22.312Z",
    transform: "translate(0 0)",
    fill: "#0b608a"
  })))));
};
var StyledSVG = /*#__PURE__*/styled("svg")({
  name: "StyledSVG",
  class: "s1nrufsp"
});
export default IconCloseCircle;